import { STARTED_BOOKING_DATA_KEY } from '../constants';
import { NavigateFunction } from 'react-router-dom';

interface BookingData {
  warehouseId?: string;
  sizeCodeId?: string;
  boxId?: string;
  unitViewMode?: string;
}

export const setBookingDataToLocalStorage = (data: BookingData, navigate: NavigateFunction): void => {
  const existingRaw = localStorage.getItem(STARTED_BOOKING_DATA_KEY);
  const existingParams = new URLSearchParams(existingRaw || '');

  Object.entries(data).forEach(([key, value]) => {
    if (value) {
      existingParams.set(key, value);
    } else {
      existingParams.delete(key);
    }
  });

  localStorage.setItem(STARTED_BOOKING_DATA_KEY, existingParams.toString());

  const currentQueryParams = new URLSearchParams(window.location.search);

  Object.entries(data).forEach(([key, value]) => {
    if (value) {
      currentQueryParams.set(key, value);
    } else {
      currentQueryParams.delete(key);
    }
  });

  const newUrl = `${window.location.pathname}?${currentQueryParams.toString()}`;

  navigate(newUrl, { replace: true });
};
